import { NextPage } from 'next'
import Block from '../../../components/Block'
import { FilterValues } from '../../../components/ui/ListSort'
import { SONGS_LIST_QUERY } from '../../../gql'
import { staticProps } from '../../../utils/createApolloClient'
import { t } from '../../../utils/index'
import { songsPath } from '../../../utils/routeHelpers'
import { Song, SortSongsEnum, VibeEnum } from '../../../__generated__/graphql'
import buildPopularPlaylist from '../components/buildPopularPlaylist'
import PlaylistsLayout from '../components/PlaylistsLayout'
import styles from '../_playlistsPage.module.scss'

const PlaylistsPage: NextPage<{
  midtempoSongs: Song[]
  upbeatSongs: Song[]
  chillSongs: Song[]
}> = ({ midtempoSongs, upbeatSongs, chillSongs }) => {
  const MidtempoPlaylistBlock = Block(
    buildPopularPlaylist(
      {
        vibeId: VibeEnum.Midtempo,
        orderBy: SortSongsEnum.CurrentlyTrending
      },
      midtempoSongs
    )
  )
  const UpbeatPlaylistBlock = Block(
    buildPopularPlaylist(
      {
        vibeId: VibeEnum.Upbeat,
        orderBy: SortSongsEnum.CurrentlyTrending
      },
      upbeatSongs
    )
  )
  const ChillPlaylistBlock = Block(
    buildPopularPlaylist(
      {
        vibeId: VibeEnum.Chill,
        orderBy: SortSongsEnum.CurrentlyTrending
      },
      chillSongs
    )
  )

  return (
    <PlaylistsLayout>
      <UpbeatPlaylistBlock
        title={t('Upbeat')}
        viewAllText={t('View all')}
        viewAllHref={songsPath({ vibe: 'upbeat' })}
        blockClasses={`${styles.currentlyTrending} is-12-tablet is-flex-column`}
      />

      <MidtempoPlaylistBlock
        title={t('Midtempo')}
        viewAllText={t('View all')}
        viewAllHref={songsPath({ vibe: 'midtempo' })}
        blockClasses={`${styles.currentlyTrending} is-12-tablet is-flex-column`}
      />

      <ChillPlaylistBlock
        title={t('Chill')}
        viewAllText={t('View all')}
        viewAllHref={songsPath({ vibe: 'chill' })}
        blockClasses={`${styles.currentlyTrending} is-12-tablet is-flex-column`}
      />
    </PlaylistsLayout>
  )
}

export const getStaticProps = staticProps({
  additionalProps: async ({ client }) => {
    const {
      data: { songs: midtempoSongs }
    } = await client.query({
      query: SONGS_LIST_QUERY,
      variables: {
        perPage: 10,
        orderBy: FilterValues.CURRENTLY_TRENDING,
        vibeId: 'midtempo'
      }
    })
    const {
      data: { songs: upbeatSongs }
    } = await client.query({
      query: SONGS_LIST_QUERY,
      variables: {
        perPage: 10,
        orderBy: FilterValues.CURRENTLY_TRENDING,
        vibeId: 'upbeat'
      }
    })
    const {
      data: { songs: chillSongs }
    } = await client.query({
      query: SONGS_LIST_QUERY,
      variables: {
        perPage: 10,
        orderBy: FilterValues.CURRENTLY_TRENDING,
        vibeId: 'chill'
      }
    })
    return {
      midtempoSongs,
      upbeatSongs,
      chillSongs
    }
  }
})

export default PlaylistsPage
